<div class="wrapper-added-to-your-list">
    <div class="header-added-to-your-list">
        <img src="https://media-cdn.tripadvisor.com/media/photo-s/0b/74/9e/d2/restourant-amphora-a.jpg" alt="">
        <span>{{'NEW_TEXT.added_to' | translate}} {{selectedListAndItem.list | matchLocale}}</span>
    </div>
    <button (click)="closeModal.emit(true)" class="custom-btn custom-btn--white xs-mt-12">
        <span>{{'LIST_SINGLE_PAGE.stay_here' | translate}}</span>
    </button>
    <button [routerLink]="[PAGES_AND_PATHS.singleItem.pagePath, selectedListAndItem.item.id]" class="custom-btn custom-btn--primary xs-mt-12">
        <span>{{'LIST_SINGLE_PAGE.view_item' | translate}}</span>
    </button>
</div>
